//import localization_de from './assets/localizations/de.json' assert {type: 'JSON'}

import { parsePhoneNumberFromString } from "libphonenumber-js/max";

export default {
  classifyPhoneNumber(value, defaultCountry = "DE") {
    const result = {
      formatted: value,
      type: null,
      isEmpty: false,
      isValid: true,
      isMobile: false,
      isFixedLine: false,
    };

    if (!value || value.trim() === "") {
      result.isEmpty = true;
      result.formatted = "";
      return result;
    }

    const parsed = parsePhoneNumberFromString(value, defaultCountry);

    if (!parsed || !parsed.isValid()) {
      result.isValid = false;
      return result;
    }

    result.formatted = parsed.formatInternational();
    result.type = parsed.getType() || null;
    result.isMobile = result.type === "MOBILE";
    result.isFixedLine = result.type === "FIXED_LINE";

    return result;
  },
  localize(key, locale = "de") {
    var localizedString = "";
    var jsonFile = null;

    // Parse correct file. JSON.parse() should usually cache the data
    switch (locale) {
      case "de":
        jsonFile = require("../assets/localizations/de.json");
        break;
      default:
        console.log("Localization file not found!");
    }

    if (key && key.length > 0 && jsonFile && jsonFile[key]) {
      localizedString = jsonFile[key];
    }

    return localizedString;
  },
  displayPhoneNotice(context, message, type = "is-info") {
    context.$buefy.notification.open({
      message: message,
      type: type,
      duration: 7000,
      position: "is-top-right",
      queue: false,
    });
  },
  displaySuccessToast(context, message = null) {
    if (!message) {
      message = "Erfolgreich gespeichert";
    }

    context.$buefy.toast.open({
      message: message,
      type: "is-success",
    });
  },
  displayErrorToast(context, error) {
    // Errors of blob requests (file downloads) arrive as a Blob, so their reason has to be
    // read first.
    const data = error?.response?.data;
    if (data instanceof Blob) {
      return data
        .text()
        .then((text) => JSON.parse(text))
        .catch(() => ({}))
        .then((parsedData) => {
          this.displayErrorToast(context, { response: { ...error.response, data: parsedData } });
        });
    }

    let message;

    if (typeof error === "string") {
      message = error;
    } else if (!error.response) {
      // No response at all, e.g. the connection dropped or the request timed out.
      message = "Der Server ist nicht erreichbar. Bitte versuche es erneut.";
    } else {
      message = "Fehler: " + error.response.data.reason;

      if (error.response.status === 500) {
        message = "Ein unerwarteter Fehler ist aufgetreten.";
      }
    }

    context.$buefy.toast.open({
      message: message,
      type: "is-danger",
    });
  },
  createEpisodeIdentification(episode) {
    if (episode.id !== '-1') {
      const paddedEpisodeNumber =
        episode.episodeNumber === null
          ? "0"
          : episode.episodeNumber < 10
          ? "0" + episode.episodeNumber
          : episode.episodeNumber;

      const episodeIdentification =
        episode.season.seasonNumber.toString() + paddedEpisodeNumber.toString();

      return episodeIdentification;
    }
    },
  createEuroStringFromCents(cents) {
    return this.createAmountStringFromCents(cents) + " €";
  },
  createAmountStringFromCents(cents) {
    return this.createAmountStringFromEuro(cents / 100.0);
  },
  createAmountStringFromEuro(euro) {
    if (isNaN(euro)) {
      return "0,00";
    }

    // 123456 => "123.456,00"
    return euro
      .toFixed(2) // add 2 zeros at the end
      .replace(".", ",") // change decimal point to comma
      .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // place a dot every thousand group
  },
  createNumberFromAmountString(amount) {
    return Number(amount.replace(".", "").replace(",", ".")) * 100;
  },
  createAmountStringFromNumber(amount) {
    return new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 2,
    }).format(amount);
  },
  createIntegerStringFromNumber(amount) {
    return new Intl.NumberFormat("de-DE", {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  },
  debounce(execFunction, waitTime) {
    let timer;
    return function (...args) {
      if (timer) {
        clearTimeout(timer);
      }

      const context = this;
      timer = setTimeout(() => {
        execFunction.apply(context, args);
      }, waitTime);
    };
  },
  downloadFile(context, url) {
    return context
      .$api({
        url: url,
        method: "GET",
        responseType: "blob",
      })
      .then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[0]
        );
        link.click();

        URL.revokeObjectURL(href);
      });
  },
  async downloadFileWithNameFetch(context, urlFilenameFetch, urlFileDownload) {
    console.log('# Downloading file from', urlFileDownload, 'with name from', urlFilenameFetch)
    let filename = null;
    let filenameFetch = context
      .$api({
        url: urlFilenameFetch,
        method: "GET",
      })
      .then((response) => {
        console.log('# Got filename', response.data)
        filename = response.data;
      });

    let fileObjectURL = null;
    let fileDownload = context
      .$api({
        url: urlFileDownload,
        method: "GET",
        responseType: "blob",
      })
      .then((response) => {
        console.log("# Got file response", response, 'with data', response.data);
        // create file link in browser's memory
        fileObjectURL = URL.createObjectURL(response.data);
        console.log("# Got ObjectURL", fileObjectURL)
      });

    return Promise.all([filenameFetch, fileDownload]).then(() => {
      // create "a" HTML element with href to file & click
      const link = document.createElement("a");
      link.href = fileObjectURL;
      link.setAttribute("download", filename);
      link.click();

      console.log('# Created download link', link);

      URL.revokeObjectURL(fileObjectURL);
    });
  },
  saveDataToLocalStorage(key, data) {
    if (data !== null) {
      localStorage.setItem(key, JSON.stringify(data));
    } else {
      localStorage.removeItem(key);
    }
    
  },
  getParsedDataFromLocalStorage(key, option = null) {
    let storedValue = localStorage.getItem(key);

    try {
      let parsedValue = JSON.parse(storedValue);

      if (
        (option === "number" && isNaN(parsedValue)) ||
        (option === "object" && parsedValue && typeof parsedValue !== "object")
      ) {
        return null;
      }

      return parsedValue;
    } catch (e) {
      return null;
    }
  },
  getParsedPageFromLocalStorage(key) {
    let storedValue = localStorage.getItem(key);

    try {
      let parsedValue = JSON.parse(storedValue);

      return parsedValue && !isNaN(parsedValue) ? parsedValue : 1;
    } catch (e) {
      return 1;
    }
  },
  createCleanSearchParamsString(searchObject) {
    if (searchObject == null) {
      return "";
    }

    let formattedParams = Object.fromEntries(
      Object.entries(searchObject).filter(([, value]) => {
        return value != null && value !== "";
      })
    );

    return new URLSearchParams(formattedParams).toString();
  },
  addLocaleTimezoneToDate(value) {
    const timezoneOffset = new Date().getTimezoneOffset() * 60000;

    return new Date(value.getTime() + timezoneOffset);
  },
  removeTimezoneForDate(value) {
    const timezoneOffset = value.getTimezoneOffset() * 60000;

    return new Date(value.getTime() - timezoneOffset);
  },
  deceasedMarker(creative) {
    return creative && creative.dateOfDeath ? " (†)" : "";
  },
  // Buefy dialogs render their message as HTML, so any value coming from the database has
  // to be escaped before it is interpolated into one.
  escapeHtml(value) {
    const replacements = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    };

    return String(value).replace(/[&<>"']/g, (char) => replacements[char]);
  },
};
